import React from 'react';
import classNames from 'classnames';

interface ConciergeBellIconProps {
  className?: string;
}

// lucide ConciergeBell, same icon as the mobile DonaBellIcon (lucide is not a web dependency).
// Wrapped like an antd icon so the menu's iconSize and item-icon className apply to it.
const ConciergeBellIcon: React.FC<ConciergeBellIconProps> = ({ className }) => (
  <span aria-hidden="true"className={classNames('anticon', className)}>
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z" />
      <path d="M20 16a8 8 0 1 0-16 0" />
      <path d="M12 4v4" />
      <path d="M10 4h4" />
    </svg>
  </span>
);

export default ConciergeBellIcon;
